/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ start: NonNullable<unknown>, end: NonNullable<unknown>, total: NonNullable<unknown> }} Render_Audio_Rendering_StatusInputs */

const en_render_audio_rendering_status = /** @type {(inputs: Render_Audio_Rendering_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rendering event ${i?.start}-${i?.end} of ${i?.total}`)
};

const fr_render_audio_rendering_status = /** @type {(inputs: Render_Audio_Rendering_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rendu de l'evenement ${i?.start}-${i?.end} sur ${i?.total}`)
};

const de_render_audio_rendering_status = /** @type {(inputs: Render_Audio_Rendering_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rendering-Ereignis ${i?.start}-${i?.end} von ${i?.total}`)
};

const it_render_audio_rendering_status = /** @type {(inputs: Render_Audio_Rendering_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Evento di rendering ${i?.start}-${i?.end} di ${i?.total}`)
};

const ru_render_audio_rendering_status = /** @type {(inputs: Render_Audio_Rendering_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Событие рендеринга ${i?.start}-${i?.end} события ${i?.total}`)
};

const es_render_audio_rendering_status = /** @type {(inputs: Render_Audio_Rendering_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Evento de representación ${i?.start}-${i?.end} de ${i?.total}`)
};

const zh_cn2_render_audio_rendering_status = /** @type {(inputs: Render_Audio_Rendering_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`渲染事件 ${i?.start}-${i?.end} 的 ${i?.total}`)
};

const ja_render_audio_rendering_status = /** @type {(inputs: Render_Audio_Rendering_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`レンダリングイベント ${i?.start}-${i?.end} / ${i?.total}`)
};

const hi_render_audio_rendering_status = /** @type {(inputs: Render_Audio_Rendering_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.total} के ${i?.start}-${i?.end} इवेंट को रेंडर किया जा रहा है`)
};

const pt_pt2_render_audio_rendering_status = /** @type {(inputs: Render_Audio_Rendering_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Renderizando evento ${i?.start}-${i?.end} de ${i?.total}`)
};

/**
* | output |
* | --- |
* | "Rendering event {start}-{end} of {total}" |
*
* @param {Render_Audio_Rendering_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const render_audio_rendering_status = /** @type {((inputs: Render_Audio_Rendering_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Render_Audio_Rendering_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_render_audio_rendering_status(inputs)
	if (locale === "de") return de_render_audio_rendering_status(inputs)
	if (locale === "it") return it_render_audio_rendering_status(inputs)
	if (locale === "ru") return ru_render_audio_rendering_status(inputs)
	if (locale === "es") return es_render_audio_rendering_status(inputs)
	if (locale === "zh-CN") return zh_cn2_render_audio_rendering_status(inputs)
	if (locale === "ja") return ja_render_audio_rendering_status(inputs)
	if (locale === "hi") return hi_render_audio_rendering_status(inputs)
	if (locale === "pt-PT") return pt_pt2_render_audio_rendering_status(inputs)
	return en_render_audio_rendering_status(inputs)
});